// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a0963e7b","545":"191ce7b3"}[chunkId] + ".chunk.js";
};